import { useState } from 'react';
import Dialogo from '@/components/Dialogo';
import { criarClinica } from '@/services/adminService';

const VAZIO = {
  nome: '',
  cidade: '',
  cnpj: '',
  planoId: '',
  gestorNome: '',
  gestorEmail: '',
  gestorSenha: '',
};

const MENSAGENS = {
  'functions/already-exists': 'Já existe uma conta com este e-mail.',
  'functions/permission-denied': 'Apenas o superadmin pode criar clínicas.',
  'functions/not-found': 'Plano não encontrado.',
  'functions/unavailable':
    'Não foi possível falar com as Cloud Functions. Elas rodam no emulador — confira se "npm run emu" está ativo.',
};

/** Onboarding de clínica: cria a clínica e o primeiro gestor numa chamada só. */
export default function DialogoNovaClinica({ aberto, aoFechar, planos }) {
  const [dados, setDados] = useState({ ...VAZIO, planoId: planos[0]?.id ?? '' });
  const [erro, setErro] = useState(null);
  const [salvando, setSalvando] = useState(false);

  const mudar = (campo) => (e) => setDados((d) => ({ ...d, [campo]: e.target.value }));

  function fechar() {
    setDados({ ...VAZIO, planoId: planos[0]?.id ?? '' });
    setErro(null);
    aoFechar();
  }

  async function salvar(evento) {
    evento.preventDefault();
    setErro(null);
    setSalvando(true);
    try {
      await criarClinica({
        nome: dados.nome,
        cidade: dados.cidade,
        cnpj: dados.cnpj,
        planoId: dados.planoId,
        gestor: {
          nome: dados.gestorNome,
          email: dados.gestorEmail,
          senha: dados.gestorSenha,
        },
      });
      fechar();
    } catch (e) {
      setErro(MENSAGENS[e.code] ?? e.message ?? 'Não foi possível criar a clínica.');
    } finally {
      setSalvando(false);
    }
  }

  return (
    <Dialogo titulo="Nova clínica" aberto={aberto} aoFechar={fechar} largura={520}>
      <form className="formulario" onSubmit={salvar}>
        <div className="linha">
          <div className="campo">
            <label htmlFor="nc-nome">Nome da clínica</label>
            <input id="nc-nome" required value={dados.nome} onChange={mudar('nome')} />
          </div>
          <div className="campo">
            <label htmlFor="nc-cidade">Cidade</label>
            <input id="nc-cidade" value={dados.cidade} onChange={mudar('cidade')} />
          </div>
        </div>

        <div className="linha">
          <div className="campo">
            <label htmlFor="nc-cnpj">CNPJ</label>
            <input id="nc-cnpj" value={dados.cnpj} onChange={mudar('cnpj')} />
          </div>
          <div className="campo">
            <label htmlFor="nc-plano">Plano</label>
            <select id="nc-plano" required value={dados.planoId} onChange={mudar('planoId')}>
              {planos.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.nome}
                </option>
              ))}
            </select>
          </div>
        </div>

        <p className="rotulo-acoes">Primeiro gestor</p>

        <div className="campo">
          <label htmlFor="nc-gnome">Nome</label>
          <input id="nc-gnome" required value={dados.gestorNome} onChange={mudar('gestorNome')} />
        </div>

        <div className="linha">
          <div className="campo">
            <label htmlFor="nc-gemail">E-mail</label>
            <input
              id="nc-gemail"
              type="email"
              required
              value={dados.gestorEmail}
              onChange={mudar('gestorEmail')}
            />
          </div>
          <div className="campo">
            <label htmlFor="nc-gsenha">Senha provisória</label>
            <input
              id="nc-gsenha"
              type="text"
              required
              minLength={8}
              placeholder="mínimo 8 caracteres"
              value={dados.gestorSenha}
              onChange={mudar('gestorSenha')}
            />
          </div>
        </div>

        {erro && <p className="erro">{erro}</p>}

        <footer className="dialogo-acoes">
          <button type="button" className="btn-secundario" onClick={fechar}>
            Cancelar
          </button>
          <button type="submit" className="btn-primario" disabled={salvando}>
            {salvando ? 'Criando…' : 'Criar clínica'}
          </button>
        </footer>
      </form>
    </Dialogo>
  );
}
